import React from 'react';
import { useTheme } from 'styled-components';

// Bağ çizgisi (spec 2026-10-24 §5.2, §5.5): yolu yerleşim hesaplar (`data.path`); React Flow'un uç koordinatları
// kullanılmaz. Kökten seçili kişiye giden yol birincil mavi ve kalın.
export default function OrgEdge({ id, data }) {
  const theme = useTheme();
  if (!data?.path) return null;
  const highlight = Boolean(data.highlight);
  return (
    <path
      id={id}
      d={data.path}
      className={highlight ? 'react-flow__edge-path org-edge hi' : 'react-flow__edge-path org-edge'}
      data-highlight={highlight ? 'true' : undefined}
      fill="none"
      style={{
        stroke: highlight ? theme.colors.primary.main : theme.colors.orgChart.line,
        strokeWidth: highlight ? 2.5 : 1.5,
        pointerEvents: 'none',
      }}
    />
  );
}
